import {ValueObject} from '@s-ui/domain'

/**
 * Value Object for favorites response containing both ads and contracts
 */
export default class UserFavoritesListValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {Array} data.ads - Array of favorite ad entities
   * @param {Array} data.contracts - Array of favorite contract entities
   * @param {Number} data.totalAds - Total count of favorite ads
   * @param {Number} data.totalContracts - Total count of favorite contracts
   */
}
